import { useState } from "react";
import { signOut } from "firebase/auth";
import { auth } from "./firebase";
import type { Me } from "./actions";
import { getTheme, setTheme, type Theme } from "./theme";

// Profile: who you are signed in as, what you may do, and your own display settings. The theme is stored in this browser only.

const THEMES: [Theme, string, string][] = [
  ["light", "Light", "Always light"],
  ["dark", "Dark", "Always dark"],
  ["system", "System", "Follow this device's setting"],
];

export function ProfilePanel({ email, me, environment }: { email: string; me: Me | null; environment: string }) {
  const [theme, setThemeState] = useState<Theme>(getTheme());
  const choose = (t: Theme) => { setTheme(t); setThemeState(t); };
  const labels = me ? me.capabilities.filter((c) => me.class === "admin" || me.caps.includes(c.key)) : [];

  return (
    <div>
      <h1>Profile</h1>
      <p className="meta">Your account and your display settings.</p>

      <h3>Appearance</h3>
      <div className="panel" style={{ maxWidth: 560 }}>
        <div role="radiogroup" aria-label="Theme" style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          {THEMES.map(([key, label, hint]) => (
            <label key={key} className={`tile${theme === key ? " active" : ""}`} style={{ cursor: "pointer", minWidth: 150, textAlign: "center" }} title={hint}>
              <input type="radio" name="theme" value={key} checked={theme === key} onChange={() => choose(key)} className="sr-only" />
              <div className="tile-value" style={{ fontSize: 18 }}>{label}</div>
              <div className="tile-label">{hint}</div>
            </label>
          ))}
        </div>
        <p className="meta" style={{ marginBottom: 0 }}>Saved in this browser only, so it does not follow you to another computer.</p>
      </div>

      <h3 style={{ marginTop: 22 }}>Account</h3>
      <table className="manual-products" style={{ maxWidth: 760 }}>
        <tbody>
          <tr><td>Signed in as</td><td>{email}</td></tr>
          <tr><td>Class</td><td>{me ? (me.class === "admin" ? "Admin (everything)" : "Staff") : "…"}</td></tr>
          <tr><td>Environment</td><td>{environment === "console" ? "Console (the real catalog data)" : "Sandbox"}</td></tr>
          <tr><td>You can</td><td className="wrap" style={{ whiteSpace: "normal" }}>
            {!me ? "…" : me.class === "admin" ? "Everything, including Users and Access." : labels.length ? labels.map((c) => c.label).join(", ") : "Nothing yet: ask an admin."}
          </td></tr>
        </tbody>
      </table>
      <p style={{ marginTop: 16 }}><button type="button" onClick={() => signOut(auth)}>Sign out</button></p>
    </div>
  );
}
